import React, { useState } from "react";

export default function SmcMap() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Prayer Intention",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
  };

  return (
    <div className="contact-page-wrapper" style={{ paddingTop: "140px", paddingBottom: "80px", background: "#fcfbf8" }}>
      <div className="container">
        {/* Page Header */}
        <div className="section-heading-wrapper text-center mb-5">
          <div className="eyebrow-badge">
            <i className="fas fa-map-marker-alt"></i>
            <span>Pilgrimage & Parish Office</span>
          </div>
          <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "clamp(2rem, 3.5vw, 2.8rem)", color: "var(--cathedral-navy)" }}>
            Contact & Visit St. Mary's Cathedral
          </h1>
          <div className="cross-ornament">
            <i className="fas fa-cross"></i>
          </div>
          <p style={{ maxWidth: "700px", margin: "0 auto", color: "var(--cathedral-text-secondary)" }}>
            We welcome pilgrims, parishioners, and visitors from near and far. Connect with our parish office or send your prayer intentions.
          </p>
        </div>

        {/* Contact Info Cards */}
        <div className="row g-4 mb-5">
          <div className="col-12 col-md-4">
            <div className="cathedral-card h-100 p-4 text-center">
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  margin: "0 auto 16px auto",
                  borderRadius: "50%",
                  background: "#f7f3e8",
                  color: "#b89547",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.3rem"
                }}
              >
                <i className="fas fa-map-marked-alt"></i>
              </div>
              <h5 style={{ fontFamily: "'Playfair Display', serif", color: "var(--cathedral-navy)", marginBottom: "8px" }}>
                Our Location
              </h5>
              <p style={{ color: "#5d6d7e", fontSize: "0.92rem", marginBottom: "12px", lineHeight: 1.6 }}>
                East Veli Street, Madurai,<br />Tamil Nadu 625001, India
              </p>
              <a
                href="https://maps.google.com/?q=St.+Mary's+Cathedral+Madurai"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm"
                style={{
                  background: "#f8f6f0",
                  color: "var(--cathedral-navy)",
                  border: "1px solid #dfd7c5",
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  padding: "5px 14px",
                  fontWeight: 600
                }}
              >
                <i className="fas fa-external-link-alt me-1"></i> Get Directions
              </a>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="cathedral-card h-100 p-4 text-center">
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  margin: "0 auto 16px auto",
                  borderRadius: "50%",
                  background: "#f7f3e8",
                  color: "#b89547",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.3rem"
                }}
              >
                <i className="fas fa-phone-volume"></i>
              </div>
              <h5 style={{ fontFamily: "'Playfair Display', serif", color: "var(--cathedral-navy)", marginBottom: "8px" }}>
                Phone & Email
              </h5>
              <p style={{ color: "#5d6d7e", fontSize: "0.92rem", marginBottom: "4px" }}>
                <strong>Parish Office:</strong> +91 91761 55356
              </p>
              <p style={{ color: "#5d6d7e", fontSize: "0.92rem", marginBottom: "12px" }}>
                <strong>Email:</strong> stmaryscathedral1841@gmail.com
              </p>
              <a
                href="tel:+919176155356"
                className="btn btn-sm"
                style={{
                  background: "#f8f6f0",
                  color: "var(--cathedral-navy)",
                  border: "1px solid #dfd7c5",
                  borderRadius: "20px",
                  fontSize: "0.8rem",
                  padding: "5px 14px",
                  fontWeight: 600
                }}
              >
                <i className="fas fa-phone-alt me-1"></i> Call Parish
              </a>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="cathedral-card h-100 p-4 text-center">
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  margin: "0 auto 16px auto",
                  borderRadius: "50%",
                  background: "#f7f3e8",
                  color: "#b89547",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.3rem"
                }}
              >
                <i className="fas fa-clock"></i>
              </div>
              <h5 style={{ fontFamily: "'Playfair Display', serif", color: "var(--cathedral-navy)", marginBottom: "8px" }}>
                Office Timings
              </h5>
              <p style={{ color: "#5d6d7e", fontSize: "0.92rem", marginBottom: "6px", lineHeight: 1.6 }}>
                <strong>Mon – Sat:</strong><br />
                9:30 AM – 1:00 PM &amp; 4:30 PM – 7:00 PM
              </p>
              <span className="badge" style={{ background: "#f5eedb", color: "#957227", border: "1px solid #ebdcb7", fontSize: "0.78rem" }}>
                Closed Sunday Afternoons
              </span>
            </div>
          </div>
        </div>

        {/* Map & Form Row */}
        <div className="row g-5 align-items-stretch">
          {/* Interactive Google Map */}
          <div className="col-lg-6">
            <div
              style={{
                height: "100%",
                minHeight: "420px",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 6px 24px rgba(27, 58, 107, 0.08)",
                border: "1px solid #e5dfd2"
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.248349472087!2d78.12565459999999!3d9.913262399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c423e48f6cbf%3A0x31adac7f092aa579!2sSt.%20Mary's%20Cathedral!5e0!3m2!1sen!2sin!4v1757045417972!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "420px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="St. Marys Cathedral Map"
              ></iframe>
            </div>
          </div>

          {/* Prayer Intentions & Inquiry Form */}
          <div className="col-lg-6">
            <div className="cathedral-card p-4 p-md-5 h-100">
              <h4 style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "var(--cathedral-navy)", marginBottom: "8px" }}>
                Submit Prayer Intentions / Inquiries
              </h4>
              <p style={{ color: "#6c7d91", fontSize: "0.92rem", marginBottom: "24px" }}>
                Entrust your intentions to the prayers of our cathedral priests and parish community.
              </p>

              {formSubmitted ? (
                <div className="p-4 rounded-3 text-center" style={{ background: "#f7f9f3", border: "1px solid #d5e5c8" }}>
                  <i className="fas fa-check-circle text-success mb-3" style={{ fontSize: "2.5rem" }}></i>
                  <h5 style={{ color: "#2d572c" }}>Thank You</h5>
                  <p style={{ color: "#4f6e4e", fontSize: "0.92rem", marginBottom: "16px" }}>
                    Your prayer intention / message has been received with reverent gratitude. Our pastoral team will keep your petitions in mind.
                  </p>
                  <button
                    className="btn-cathedral-outline btn-sm"
                    onClick={() => {
                      setFormSubmitted(false);
                      setFormData({ name: "", email: "", phone: "", subject: "Prayer Intention", message: "" });
                    }}
                  >
                    Submit Another Intention
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--cathedral-navy)" }}>
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="e.g. John Peter"
                      style={{ borderRadius: "8px", borderColor: "#ded6c5", padding: "10px 14px" }}
                    />
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-sm-6">
                      <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--cathedral-navy)" }}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="name@example.com"
                        style={{ borderRadius: "8px", borderColor: "#ded6c5", padding: "10px 14px" }}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--cathedral-navy)" }}>
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="+91 98765 43210"
                        style={{ borderRadius: "8px", borderColor: "#ded6c5", padding: "10px 14px" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--cathedral-navy)" }}>
                      Inquiry Category
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="form-select"
                      style={{ borderRadius: "8px", borderColor: "#ded6c5", padding: "10px 14px" }}
                    >
                      <option value="Prayer Intention">Prayer Intention for Holy Mass</option>
                      <option value="Sacramental Inquiry">Sacraments (Baptism, Wedding, Holy Communion)</option>
                      <option value="Certificate Request">Parish Certificate Request</option>
                      <option value="Substation Inquiry">Substation &amp; Anbiyam Information</option>
                      <option value="General Question">General Inquiry</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="form-label" style={{ fontSize: "0.85rem", fontWeight: 600, color: "var(--cathedral-navy)" }}>
                      Your Petition / Message *
                    </label>
                    <textarea
                      name="message"
                      rows="4"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Write your prayer intentions or inquiry here..."
                      style={{ borderRadius: "8px", borderColor: "#ded6c5", padding: "10px 14px" }}
                    ></textarea>
                  </div>

                  <button type="submit" className="btn-cathedral-primary w-100">
                    <i className="fas fa-paper-plane me-2"></i> Submit Petition / Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
